const objeto8 = {
    titulo: `Objetos: Propiedades calculadas`,
    problemas: [
        {
            codigo: 1,
            descripcion: `El concepto de propiedades calculadas o computadas en JavaScript, nos permiten usar nombres generados dinámicamente dentro de los objetos literales.
El nombre de la propiedad se calcula cuando se ejecuta el código.
Se encierra entre corchetes el nombre de una variable que se usará para calcular el valor de la propiedad del objeto literal.
<code>
let estudios='universitario'

const persona = {
  nombre: 'Juan',
  apellido: 'Perez',
  [estudios]:'si'
}

console.log(persona) // {nombre:'Juan', apellido:'Perez',universitario: 'si'} 
</code>
En tiempo de ejecución la propiedad calculada se remplaza por el valor de la variable estudios. Es decir por el nombre 'universitario'`,
            programa: `const estudios='universitario'

const persona = {
  nombre: 'Juan',
  apellido: 'Perez',
  [estudios]:'si'
}

console.log(persona)`,
            solucion: "{nombre:'Juan', apellido: 'Perez', universitario: 'si' }",
        }, {
            codigo: 2,
            descripcion: `Podemos generar el nombre de la variable a partir de una operación.`,
            programa: `const mes = 'Enero'
const dia = 1

const deuda = {
  nombre: 'Juan',
  apellido: 'Perez',
  [mes + dia]: 100
}

console.log(deuda)`,
            solucion: "{nombre:'Juan', apellido: 'Perez', Enero1: 100 }",
        }, {
            codigo: 3,
            descripcion: `Si se sustituye por un nombre de propiedad que tiene espacios en blanco, luego debemos indicar con comillas simples o dobles dicha propiedad.`,
            programa: `let seccion ='Ventas y Compras'
    
const empleado1 = {
  nombre: 'Juan',
  apellido: 'Perez',
  [seccion]: 'Ventas'
}

console.log(empleado1)`,
            solucion: "{nombre:'Juan', apellido: 'Perez', 'Ventas y Compras': 'Ventas' }",
        }, {
            codigo: 4,
            descripcion: `Recordemos que para acceder a propiedades con espacios en blanco no podemos utilizar la notación de (.) sino que debemos utilizar la notación de ([]).`,
            programa: `let seccion ='Ventas y Compras'   

const empleado1 = {
  nombre: 'Juan',
  apellido: 'Perez',
  [seccion]: 'Ventas'
}

console.log(empleado1['Ventas y Compras'])`,
            solucion: "'Ventas'",
        }
    ]
}

export default objeto8;